<template>
    <div class="password-login-container" :class="{ 'paddingTop': status === 1 }">
        <div class="password-login-tip" :class="`${tipStatus}-tip`" v-if="tipStatus !== 'none' && status === 1">
            <div>
                <span class="tip_text">{{ tipMessage }}</span>
            </div>
            <div @click="closeTip" class="cursor-pointer"></div>
        </div>
        <el-form ref="account" :model="entity" :rules="rules" label-position="left" hide-required-asterisk>
            <div v-if="status === 0">
                <el-form-item prop="username">
                    <el-form-item prop="mobilePhone">
                        <el-input ref="usernameInput" v-model="entity.username"
                            @keyup.native.enter="focusInput('passwordInput')" placeholder="请输入手机号" maxlength="11"
                            show-word-limit clearable>
                            <template slot="prepend"><img src="@/assets/img/login/account.png" /></template>
                        </el-input>
                    </el-form-item>
                </el-form-item>
            </div>
            <div class="password-container" v-if="status === 0">
                <el-form-item prop="password">
                    <el-input ref="passwordInput" v-model="entity.password"
                        @keyup.native.enter="focusInput('codeInput')" placeholder="请输入登录密码" maxlength="16" clearable
                        show-password>
                        <template slot="prepend"><img src="@/assets/img/login/lock.png" /></template>
                    </el-input>
                </el-form-item>
            </div>
            <div class="code-container" v-if="status === 1">
                <el-form-item prop="verificationCode">
                    <el-input ref="codeInput" auto-complete="new-password" v-model="entity.verificationCode"
                        @input="(value) => entity.verificationCode = value.replace(/[^\d]/g, '')" placeholder="请输入验证码"
                        @keyup.native.enter="focusInput('submitBtn')" maxlength="6">
                    </el-input>
                    <el-button class="code-button" type="primary" plain @click="popupSlidingCaptcha()"
                        :disabled="getCaptchaDisabled" stopCountDown>
                        {{ codeMessage }}
                    </el-button>
                </el-form-item>
            </div>
        </el-form>
        <div class="operate-line" v-if="status === 0">
            <div class="remember-account">
                <el-checkbox v-model="rememberAccount" style="margin-right: 5px;" @change="handleRememberChange"></el-checkbox>
                <span>记住账号</span>
            </div>
            <div class="forgot-password">
                <span class="no-account" @click="forgetPassword">忘记密码？</span>
            </div>
        </div>
        <Explain />
        <el-button class="submit-btn" ref="submitBtn" type="primary" size="long"
            @keyup.native.enter="submitForm('account')" @click="submitForm('account')"
            :loading="loading">
            登录
        </el-button>
        <div class="go-back-btn" @click="goBack()" v-if="status === 1">返回上一步</div>
    </div>
</template>

<script>
import { login } from '@/api/home/login';
import CaptchaApi from '@/api/system/captchaApi';
import localCache from '@/localCache';
import Fingerprint from '@/utils/fingerprint';
import Explain from "./explain.vue";

export default {
    components: { Explain },
    data() {
        return {
            entity: {
                grant_type: 'password', // 效验类型
                username: '', // 用户名
                password: '', // 密码
                verificationCode: '' // 验证码
            },
            rememberAccount: false, // 记住账号
            codeMessage: '发送验证码', // 验证码提示
            rules: {
                username: [{ required: true, message: '请输入手机号！' }],
                password: [{ required: true, message: '请输入登录密码！' }, { min: 8, max: 16, message: '密码为8到16位!', trigger: 'blur' }],
                verificationCode: [{ required: true, message: '请输入验证码!' }, { len: 6, message: '验证码长度必须为6位!', trigger: 'blur' }]
            },
            status: 0, // 登录状态：0.输入账号密码 1.输入验证码
            tipStatus: 'none', // 提示状态：none.消失 success.成功 fail.失败
            tipMessage: '', // 提示内容
            fingerprint: null, // 指纹识别对象
            loading: false // 登录按钮加载状态
        };
    },
    computed: {
        // 获取验证码按钮-禁用状态
        getCaptchaDisabled() {
            return this.codeMessage !== '发送验证码';
        }
    },
    mounted() {
        // 读取是否记住账号
        this.rememberAccount = localCache.get('REMEMBER_ACCOUNT') ? true : false;
        // 如果记住账号，则读取账号
        if (this.rememberAccount) {
            this.entity.username = localCache.get('LOGIN_ACCOUNT') || '';
        }
    },
    methods: {
        /**
         * @description: 聚焦到指定输入框
         * @param {String} name 注册的ref名称
         */
        focusInput(name) {
            if (name == 'submitBtn') {
                this.$refs[name].click();
            } else {
                this.$refs[name].focus();
            }
        },
        /**
         * @description 关闭提示
         */
        closeTip() {
            this.tipStatus = 'none';
        },

        /**
         * @description 弹出滑块验证
         */
        popupSlidingCaptcha() {
            this.closeTip();
            this.$emit('popup');
        },
        /**
         * @description 获取验证码
         */
        getVerificationCode(key) {
            let data = { mobilePhone: this.entity.username, useType: 'WEB_LOGIN', slidingCaptchaKey: key };
            CaptchaApi.getPhoneCaptcha(data).then(res => {
                if (res && res.code === '00000') {
                    this.entity.verificationCode = '';
                    this.status = 1;
                    this.tipMessage = `尾号${this.entity.username.slice(-4)}的验证码短信已发送至您的手机`;
                    this.tipStatus = 'success';
                    this.countDown(60);
                    this.$nextTick(() => {
                        this.$refs['account'].clearValidate();
                    });
                }
            });
        },

        /**
         * @description 记住账号复选框值变化
         * @param value 记住账号复选框值
         */
        handleRememberChange(value) {
            localCache.set('REMEMBER_ACCOUNT', value);
            if (value) {
                if (this.entity.username) localCache.set('LOGIN_ACCOUNT', this.entity.username);
            } else {
                localCache.remove('LOGIN_ACCOUNT');
            }
        },

        /**
         * @description 忘记密码
         */
        forgetPassword() {
            window.open(process.env.VUE_APP_URL + '#/forgetPassword', '_blank');
        },

        /**
         * @description: 获取手机验证码后按钮变60秒倒计时
         */
        countDown(n) {
            this.codeMessage = n + 's后重试';
            setTimeout(() => {
                n--;
                if (n > 0) {
                    this.countDown(n);
                } else {
                    this.codeMessage = '发送验证码';
                }
            }, 1000);
        },

        /**
         * @description: 登录提交
         */
        submitForm(formName) {
            this.$refs[formName].validate((valid => {
                if (!valid) {
                    return;
                }
                this.closeTip();
                this.fingerprint = this.fingerprint || new Fingerprint();
                Promise.all([this.$refs[formName].validate(), this.fingerprint.getValue()]).then(([valid, result]) => {
                    this.loading = true;
                    login({ ...this.entity, macAddress: result }, true).then(res => {
                        if (res?.model) {
                            if (res.model.captcha) {
                                // 弹出验证滑块
                                this.popupSlidingCaptcha();
                            } else if (res.model.accessToken && res.model.tokenType) {
                                this.$emit("login-success", res.model.tokenType + res.model.accessToken);
                            }
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            }));
        },

        /**
         * @description 返回上一步
         */
        goBack() {
            this.status = 0;
            this.closeTip();
            this.entity.verificationCode = '';
            this.entity.password = '';
            if (!this.rememberAccount) {
                this.entity.username = '';
            }
            this.$nextTick(() => { this.$refs['account'].clearValidate(); });
        }
    }
};
</script>
<style scoped lang="less">
.password-login-container {
    width: 100%;

    .password-login-tip {
        width: 100%;
        height: 24px;
        box-sizing: border-box;
        margin: 10px 0 5px;

        .tip_text {
            margin-left: 6px;
            font-size: 12px;
        }
    }

    .success-tip {
        background-color: #F0FFF8;
        border: 1px solid #27d17e;

        .tip_text {
            color: #27D17E;
        }
    }

    .error-tip {
        background-color: #FFF0F0;
        border: 1px solid #fc8080;

        .tip_text {
            color: #FC8080;
        }
    }

    .success-tip,
    .error-tip {
        & + .el-form .code-container {
            padding-top: 0;
        }
    }

    // 表单
    .el-form {
        width: 100%;
        padding-top: 10px;

        /deep/ .el-input-group__prepend {
            background-color: transparent;

            &::after {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                margin: auto;
                width: 1px;
                height: 16px;
                background: #979EA5;
            }

            img {
                width: 20px;
                height: 20px;
            }
        }

        .el-input {
            & /deep/ .el-input__inner {
                border-left: none !important;
            }
        }

        .password-container .el-form-item {
            margin-bottom: 14px;
        }

        .code-container {
            padding-top: 20px;
            & /deep/ .el-input__inner {
                border-left: 1px solid #dde2e9 !important;
            }
        }

        & + .el-button {
            margin-top: 30px;
        }
    }

    .operate-line {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;

        .remember-account {
            display: flex;
            align-items: center;
            color: #222;
        }
        .no-account {
            color: #FF8201;
            cursor: pointer;
        }
    }

    // 按钮
    .el-button {
        &.el-button--long {
            width: 100%;
            height: 48px;
            margin-top: 20px;
            font-size: 16px;
            font-family: @font-medium;
            border-radius: 4px;
            border: none;
        }

        &.el-button--long,
        &.el-button--long:focus,
        &.el-button--long:hover {
            background: linear-gradient(90deg, #ff9b02 0%, #ff8100 100%);
        }
    }

    .go-back-btn {
        margin-top: 13px;
        text-align: center;
        font-size: 14px;
        color: #FF8201;
        cursor: pointer;
    }
}

.code-container {
    :deep(.el-form-item__content) {
        display: flex;
        .el-input {
            flex: 1;
        }

        .code-button {
            width: 91px;
            height: 46px;
            text-align: center;
            background: #f6f8fa;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #dde2e9;
            margin-left: 9px;
            font-size: 14px;
            padding: 12px 0;
            color: #1D2129;

            &.is-disabled {
                background-color: #fafafa !important;
                color: #737373 !important;
            }
        }
    }
}
</style>
